// Identidad del experimento en curso. Este módulo NO reparte tráfico: lo hacen Shopify
// Rollouts, el anuncio (?view=) o una app. Hace lo único que ninguno de ellos expone:
// que la rama llegue a la medición y al pedido.
//
// La rama son las dos cosas que pueden cambiar entre versiones sin ambigüedad: el sufijo
// de plantilla, que viene del servidor, y el tema, que en un experimento de Rollouts es
// una copia con id propio. Se lee de Shopify.theme y no del objeto Liquid, que está
// deprecado justamente porque sus valores pueden cambiar.

const context = window.themeExperiment;
const ATTRIBUTE = '_pdp_variant';

if (context) {
  const theme = window.Shopify?.theme;
  context.themeId = theme?.id ?? null;
  context.themeName = theme?.name ?? null;
  context.variant = `${context.suffix}@${context.themeId ?? 'unknown'}`;

  // Exposición, una vez por vista. GTM la reenvía a GA4 como dimensión pdp_variant.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'experiment_exposure',
    pdp_variant: context.variant,
    experiment_template: context.template,
    experiment_theme_id: context.themeId,
  });

  // Clarity, como etiqueta personalizada: deja filtrar grabaciones, mapas de calor y
  // panel por rama. GA4 dice cuál gana; esto dice por qué. La cola `clarity.q` recoge
  // la llamada aunque el script todavía no haya cargado.
  try {
    window.clarity?.('set', 'pdp_variant', context.variant);
  } catch {
    // Clarity ausente o bloqueado: la medición principal no depende de esto.
  }

  // El atributo viaja al pedido de Shopify y de ahí a Odoo, que es la verdad de las
  // ventas. Gana la primera rama que selle el carrito: la asignación es estable, así
  // que una segunda escritura solo puede venir de una página fuera de la prueba.
  let pending = false;
  context.stamp = async () => {
    if (pending) return;
    pending = true;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (cart.attributes?.[ATTRIBUTE]) return;
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [ATTRIBUTE]: context.variant } }),
      });
    } catch {
      pending = false;
    }
  };
}
